<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Edit goods receiving</div>

            <fieldset class="border p-2">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Edit goods receiving</small
                >
              </legend>
              <div>
                <form @submit.prevent="updateGoods()">
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Product</th>
                            <th scope="col">Quantity</th>
                            <th scope="col text-right">Unit price</th>
                            <th scope="col text-right">Remark</th>
                            <th scope="col text-right">Total</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(invoice_product, k) in EditGoodsReceiving"
                            :key="k"
                          >
                            <td scope="row">
                              <button type="button" class="btn btn-primary">
                                <i class="fa fa-edit"></i>
                              </button>
                              <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, invoice_product)"></i> -->
                            </td>
                            <td>
                              <select
                                class="form-control product_id"
                                v-model="invoice_product.product_id"
                                readonly
                                disabled
                              >
                                <option value>Select product</option>
                                <option
                                  v-for="product in systemProducts"
                                  :value="product.id"
                                  :key="product.id"
                                >
                                  {{ product.product_name }}
                                </option>
                              </select>
                            </td>
                            <td>
                              <input
                                class="form-control"
                                type="number"
                                min="0"
                                step=".01"
                                v-model="invoice_product.qty"
                                @change="calculateLineTotal(invoice_product)"
                              />
                            </td>
                            <td>
                              <input
                                class="form-control"
                                type="number"
                                min="0"
                                step=".01"
                                v-model="invoice_product.unit_price"
                                @change="calculateLineTotal(invoice_product)"
                              />
                            </td>

                            <td>
                              <input
                                class="form-control"
                                type="text"
                                v-model="invoice_product.remarks"
                              />
                            </td>
                            <td>
                              <input
                                readonly
                                class="form-control text-right"
                                type="number"
                                min="0"
                                step=".01"
                                v-model="invoice_product.total_price"
                              />
                            </td>
                          </tr>
                          <tr v-show="EditGoodsReceiving.length === 0">
                            <td colspan="7">
                              <p class="text-center alert-danger p-2">
                                No products added/available.
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="5" class="text-right">Total</td>
                            <input
                              readonly
                              class="form-control text-right goods_grand_total"
                              type="number"
                              min="0"
                              step=".01"
                              :value="Total.toFixed(2)"
                            />
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    <div class="clearfix"></div>
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat updatingGoodreceiving btn-rounded"
                    >
                      <i class="fa fa-plus"></i> receive goods
                    </button>
                    <button
                      type="button"
                      class="btn-rounded btn-flat updatingGoodreceivingLoader btn-rounded"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import $ from "jquery";
import router from "../router/index";
import { ModelListSelect } from "vue-search-select";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
      idx: [],
    };
  },
  created() {
    if (this.$store.getters.EditGoodsReceiving.length === 0) {
      router.push("/managegoodsreceiving");
    }
    this.loadProduct();
  },
  computed: {
    ...mapGetters([
      "EditGoodsReceiving",
      "systemProducts",
      "Goodreceiving",
      "GoodReceiving",
    ]),
    Total() {
      return this.EditGoodsReceiving.reduce(
        (acc, item) => acc + item.unit_price * item.qty,
        0
      );
    },
  },

  methods: {
    ...mapActions(["loadProduct", "updateGoods", "returnGoods"]),
    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.EditGoodsReceiving.reduce(function (sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(invoice_product) {
      var total =
        parseFloat(invoice_product.unit_price) *
        parseFloat(invoice_product.qty);
      if (!isNaN(total)) {
        invoice_product.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(idx, invoice_product) {
      var idx = this.EditGoodsReceiving.indexOf(invoice_product);
      console.log(idx, invoice_product);
      if (idx > -1) {
        this.EditGoodsReceiving.splice(idx, 1);
      }
      this.calculateTotal();
    },
  },
  components: {
    ModelListSelect,
  },
};
</script>
<style scoped>
.updatingGoodreceivingLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/goodsreceiving/editnote.vue